import { Component } from "react";
import "./SelectionBehaviour.css";
import PropTypes from "prop-types";
import { DictionaryMode } from "../DictionaryTools/DictionaryTools";
import NoDictionarySelection from "./NoDictionarySelection";
import Action from "./../formElements/Action/Action";
import defineImg from "./images/define.svg";
import translateImg from "./images/translate.svg";
import bookmark from "../../images/dictionary_bookmark.svg";
import { Translation } from "react-i18next";

const CONTEXT_MENU_WIDTH = 155;
const CONTEXT_MENU_HEIGHT = 100;

export default class SelectionBehaviour extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectionStarted: false,
      showContextMenu: false,
    };

    this.onSelectStart = this.onSelectStart.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.openSidebar = this.openSidebar.bind(this);
    this.clearState = this.clearState.bind(this);
    this.onCtxMenuEvent = this.onCtxMenuEvent.bind(this);
  }

  componentDidMount() {
    const parent = document.getElementById(this.props.scrollableParentId);
    if (parent) {
      parent.addEventListener("selectstart", this.onSelectStart);
      parent.addEventListener("selectionchange", this.onSelectionChange);
      parent.addEventListener("mouseup", this.onMouseUp);
    }
  }

  componentWillUnmount() {
    const parent = document.getElementById(this.props.scrollableParentId);
    if (parent) {
      parent.removeEventListener("selectstart", this.onSelectStart);
      parent.removeEventListener("selectionchange", this.onSelectionChange);
      parent.removeEventListener("mouseup", this.onMouseUp);
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.isContextMenuOpened !== this.props.isContextMenuOpened) {
      this.setState({ showContextMenu: nextProps.isContextMenuOpened });
    }
  }

  componentDidUpdate() {
    if (this.state.showContextMenu) {
      if (this.defineLink) {
        this.defineLink.addEventListener("selectstart", this.onCtxMenuEvent);
        this.defineLink.addEventListener("mouseup", this.onCtxMenuEvent);
      }
      if (this.translateLink) {
        this.translateLink.addEventListener("selectstart", this.onCtxMenuEvent);
        this.translateLink.addEventListener("mouseup", this.onCtxMenuEvent);
      }
      if (this.saveWordLink) {
        this.saveWordLink.addEventListener("selectstart", this.onCtxMenuEvent);
        this.saveWordLink.addEventListener("mouseup", this.onCtxMenuEvent);
      }
    }
  }

  onSelectStart() {
    this.setState({ selectionStarted: true, showContextMenu: false });
  }

  onSelectionChange() {
    //console.log("New selection made");
  }

  onMouseUp(event) {
    if (
      event.target.closest &&
      event.target.closest("." + NoDictionarySelection.CLASS_NAME)
    ) {
      // There are some components that should not support selection with context menu.
      this.setState({
        selectionStarted: false,
        showContextMenu: false,
        selection: null,
      });
      return;
    }
    const selection = document.getSelection().toString().trim();

    if (this.state.selectionStarted && selection) {
      let left = event.pageX;
      if (event.pageX > window.innerWidth - CONTEXT_MENU_WIDTH) {
        left = event.pageX - CONTEXT_MENU_WIDTH - 10;
      }
      let top = event.pageY;
      if (event.pageY > window.innerHeight - CONTEXT_MENU_HEIGHT) {
        top = event.pageY - CONTEXT_MENU_HEIGHT;
      }
      const scrollableParent = document.getElementById(this.props.scrollableParentId);
      const positionalParent = document.getElementById(this.props.positionalParentId);
      let relX = left - positionalParent.offsetLeft;
      let relY = top - scrollableParent.offsetTop + scrollableParent.scrollTop;
      this.setState({
        selectionStarted: false,
        showContextMenu: true,
        selection: selection,
        style: {
          position: "absolute",
          top: relY + 10 + "px",
          left: (relX > 20 ? relX - 20 : relX) + "px",
        },
      });
      this.props.updateParentState && this.props.updateParentState(true);
    }
  }

  onCtxMenuEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  openSidebar = mode => () => {
    this.props.openSidebar(this.state.selection, mode);
    this.clearState();
  };

  clearState() {
    this.setState({
      showContextMenu: false,
      selection: null,
      style: null,
    });
  }

  render() {
    return (
      <Translation>
        {t => (
          <span>
            {this.state.showContextMenu && (
              <div className="selection-context-menu" style={this.state.style}>
                <Action
                  className="btn action-with-image"
                  onClick={this.openSidebar(DictionaryMode.DEFINE)}
                >
                  <img src={defineImg} height={30} width={30} alt="define" />
                  <span ref={c => (this.defineLink = c)}>{t("Common.DEFINE")}</span>
                </Action>
                <span className="vertical-separator"></span>
                <Action
                  className="btn action-with-image"
                  onClick={this.openSidebar(DictionaryMode.TRANSLATE)}
                >
                  <img src={translateImg} height={30} width={30} alt="translate" />
                  <span ref={c => (this.translateLink = c)}>{t("Common.TRANSLATE")}</span>
                </Action>
                <span className="vertical-separator"></span>
                <Action
                  className="btn action-with-image"
                  onClick={this.openSidebar(DictionaryMode.SAVE)}
                >
                  <img src={bookmark} height={30} width={30} alt="save word" />
                  <span ref={c => (this.saveWordLink = c)}>
                    {t(
                      `Common.SAVE ${this.state.selection.split(" ").length > 1 ? "PHRASE" : "WORD"}`
                    )}
                  </span>
                </Action>
              </div>
            )}
          </span>
        )}
      </Translation>
    );
  }
}

SelectionBehaviour.propTypes = {
  openSidebar: PropTypes.func.isRequired,
};
